<template>
  <vxe-grid
    ref="table"
    size="mini"
    border="inner"
    resizable
    auto-resize
    highlight-hover-row
    :loading="loading"
    :data="tableData"
    :columns="columns"
    :height="tableHeight"
    :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
    :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    row-id="userCode"
    :checkbox-config="{ trigger: 'row', highlight: true, reserve: true }"
    @checkbox-change="checkboxChange"
    @checkbox-all="checkboxChange"
  >
    <template #toolbar_form>
      <slot name="header"></slot>
    </template>
    <template #pager>
      <slot name="pager"></slot>
    </template>
    <template #empty>
      <div class="text-center">
        <img src="/image/static/img/nodata.png" />
        <p class="m-0 mt-2">
          {{ $l('INDEX.table_label_empty') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>

<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableHeight: { type: Number, default: 500 },
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  computed: {
    columns() {
      return tableColumns(this)
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('chooseChange', records.concat(reserves))
    },
  },
}
</script>
